import e from "./design-system.es873.js";
import o from "./design-system.es874.js";
function t(r) {
  return o.call(this, r, e);
}
t.prototype = Object.create(o.prototype, {});
t.prototype.constructor = t;
export {
  t as AsYouType
};
//# sourceMappingURL=design-system.es308.js.map
